import type { BarDuration } from '@einhaus/project314-types';
import Card from '@/components/UI/Card';
import { formatEnumLabel } from './helpers';
import type { ObvAuditEntity, ObvAuditResponse } from './types';

interface AuditSummaryCardsProps {
    auditData: ObvAuditResponse;
    entity: ObvAuditEntity;
    filteredEventCount: number;
    resolvedDuration: BarDuration;
    selectedDateTime: string | null;
}

const AuditSummaryCards = ({ auditData, entity, filteredEventCount, resolvedDuration, selectedDateTime }: AuditSummaryCardsProps) => (
    <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-5">
        <Card responsivePadding title="Symbol">
            <div className="text-2xl font-semibold text-zinc-100">{entity.symbol}</div>
            <div className="mt-1 text-sm text-zinc-400">{entity.name || 'Unnamed asset'}</div>
        </Card>
        <Card responsivePadding title="Duration">
            <div className="text-2xl font-semibold text-zinc-100">{resolvedDuration}</div>
            <div className="mt-1 text-sm text-zinc-400">{auditData.metadata.barCount} bars reviewed</div>
        </Card>
        <Card responsivePadding title="Events">
            <div className="text-2xl font-semibold text-zinc-100">
                {filteredEventCount} / {auditData.metadata.eventCount}
            </div>
            <div className="mt-1 text-sm text-zinc-400">Filtered vs total OBV events in current audit window</div>
        </Card>
        <Card responsivePadding title="Focused DateTime">
            <div className="text-lg font-semibold text-zinc-100">{selectedDateTime ?? 'Latest state'}</div>
            <div className="mt-1 text-sm text-zinc-400">Daily snapshot date {auditData.metadata.focusedDailySnapshotDate ?? 'n/a'}</div>
        </Card>
        <Card responsivePadding title="Latest Bias">
            <div className="text-2xl font-semibold text-zinc-100">
                {formatEnumLabel(auditData.latestState?.state.summary.directionalBias)}
            </div>
            <div className="mt-1 text-sm text-zinc-400">{formatEnumLabel(auditData.latestState?.state.summary.signalRelationship)}</div>
        </Card>
    </div>
);

export default AuditSummaryCards;
